export interface ImageProbeSize {
  width: number;
  height: number;
}

const imageProbeSize = (path: string): Promise<ImageProbeSize> =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () =>
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
    img.onerror = () => reject(new Error(`Failed to load image at "${path}"`));
    img.src = path;
  });

export default imageProbeSize;
